import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import CreateCustomFieldDefinitionMutation from '../../../../../mutations/ticketing/admin/useCreateCustomFieldDefinitionMutation';

export interface CreateCustomFieldDefinitionInput {
	name: string;
	key: string;
	fieldType: 'FREE_TEXT' | 'DROPDOWN';
	options?: string[];
	readOnly?: boolean;
	requiredOnResolution?: boolean;
}

export function useCreateCustomFieldDefinition() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function create(input: CreateCustomFieldDefinitionInput): Promise<void> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				CreateCustomFieldDefinitionMutation,
				input,
				() => {
					setLoading(false);
					resolve();
				},
				err => {
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {create, loading, error, setError};
}
